module.exports = __webpack_public_path__ + "static/media/noa_sweatshirt_back.ae6a3b05.jpg";